import React, { useState, useEffect } from 'react';
import { getProjects } from '../api/services';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './ProjectsPage.css';

function ProjectsPage() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    getProjects()
      .then(res => {
        if (res.success) setProjects(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  // Get unique categories for filter
  const categories = ['all', ...new Set(projects.map(p => p.category))];

  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(p => p.category === filter);

  if (loading) {
    return (
      <>
        <Header />
        <div className="projects-page">
          <div className="container" style={{ padding: '100px 0', textAlign: 'center' }}>
            <p>Loading projects...</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="projects-page">
        <div className="container">
          {/* Page Banner */}
          <section className="projects-banner">
            <h1>Our Projects</h1>
            <p>Showcasing our landscaping excellence across residential and commercial spaces</p>
          </section>

          {/* Filter Buttons */}
          <div className="projects-filter">
            {categories.map(cat => (
              <button
                key={cat}
                className={`filter-btn ${filter === cat ? 'active' : ''}`}
                onClick={() => setFilter(cat)}
              >
                {cat.charAt(0).toUpperCase() + cat.slice(1)}
              </button>
            ))}
          </div>

          {/* Projects Grid */}
          {filteredProjects.length === 0 ? (
            <p className="no-projects">No projects found in this category.</p>
          ) : (
            <div className="projects-grid">
              {filteredProjects.map(project => (
                <div key={project.id} className="project-card">
                  <div className="project-image">
                    <img 
                      src={project.cover_image || '/images/placeholder.jpg'} 
                      alt={project.title} 
                    />
                    <span className="project-category">{project.category}</span>
                  </div>
                  <div className="project-info">
                    <h3>{project.title}</h3>
                    <p>{project.location}</p>
                    <p className="project-desc">{project.short_desc}</p>
                    <a href={`/projects/${project.slug}`} className="btn-view">
                      View Details →
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ProjectsPage;